/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Modal, Dimmer, Loader, Label } from 'nallian-shared-ui/lib/components';
import communityMemberService from '../services/communityMemberService';
import OrganisationInfo from '../../../organisation/info/components/OrganisationInfo';
import IdentificationCodes from './IdentificationCodes';

const ModalHeader = styled(({ content, ...rest }) => <Label ribbon content={content} {...rest} />)`
  &.ui.label {
    display: block;
    width: min-content;
    margin: 0 0 1rem;

    :not(:first-child) {
      margin: 2rem 0 1rem;
    }
  }
`;

const ViewCommunityMemberModal = ({
  open,
  redirectRoute,
  organisationId,
  communityId,
  dispatchCommunityMemberGet,
  communityMemberFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (open && organisationId && communityId) {
      dispatchCommunityMemberGet(communityId, organisationId, t);
    }
  }, [t, open, organisationId, communityId, dispatchCommunityMemberGet]);

  const handleModalClose = useCallback(() => navigate(redirectRoute), [redirectRoute, navigate]);

  const { pending } = communityMemberFetch;

  if (!open) return null;

  return (
    <Modal open closeIcon onClose={handleModalClose}>
      <Dimmer active={pending} inverted>
        <Loader />
      </Dimmer>
      <Modal.Header>
        {!pending ? (
          <>
            {t('membershipOf', {
              organisation: get(communityMemberFetch, 'value.organisation.name', '...'),
            })}
            <Label
              content={get(communityMemberFetch, 'value.state.name', '...')}
              floated="right"
              basic
              size="large"
            />
          </>
        ) : (
          t('membershipOf')
        )}
      </Modal.Header>
      <Modal.Content>
        <>
          <ModalHeader content={t('organisationInfo')} />
          <OrganisationInfo
            organisationId={organisationId}
            communityMemberFetch={communityMemberFetch}
          />
          <ModalHeader content={t('identificationCodes')} />
          <IdentificationCodes communityMemberFetch={communityMemberFetch} />
        </>
      </Modal.Content>
    </Modal>
  );
};

ViewCommunityMemberModal.propTypes = {
  dispatchCommunityMemberGet: PropTypes.func.isRequired,
  communityMemberFetch: PropTypes.object.isRequired,
  communityId: PropTypes.string.isRequired,
  organisationId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  redirectRoute: PropTypes.string,
};

ViewCommunityMemberModal.defaultProps = { redirectRoute: '/community/members' };

export default communityMemberService(ViewCommunityMemberModal);
